module.exports = __webpack_public_path__ + "img/verde_17_11_b.7ba48f6d.jpg";